import React, { ReactNode } from 'react';
import styles from './styles.module.css';

export default function PageWrapper({
  children,
  className = '',
  style = {},
}: {
  children: ReactNode;
  className?: string;
  style?: any;
}) {
  return (
    <div className={`${styles.wrapper} ${className}`} style={style}>
      {children}
    </div>
  );
}
